// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useMemo, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import {
  fetchAttachedProgramCoursesByIdOpen,
  fetchProgramCoursesByIdOpen,
} from '../../../actions/enrollment.action'
import { headerAction } from '../../../actions/header.action'
import {
  fetchPublicAggregateRatingsCall,
  fetchPublicRatingReviewStatus,
} from '../../../actions/reviewratings.action'
import LoadingBar from '../../../components/common/LoadingBar'
import AvailableProgramDetail from '../../../components/sis/student/availablePrograms/availableProgramDetails/AvailableProgramDetail'
import { ERR_PROGRAM_IN_ACTIVE, MENUITEMS, ROUTES } from '../../../helpers/constants'
import { selectMetaData, selectSchool, selectUser } from '../../../helpers/selectors'
import { getSchoolUrl, isEmpty, noop } from '../../../helpers/utils'
import withRouteContext from '../../../hocs/RouterContextHOC'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function ProgramDetailsOpenContainer({
  headerAction,
  fetchProgramCoursesByIdOpen,
  user,
  school,
  fetchPublicAggregateRatingsCall,
  fetchPublicRatingReviewStatus,
  fetchAttachedProgramCoursesByIdOpen,
  metadata,
}) {
  const { t } = useTranslation()
  const history = useHistory()
  const { progId } = useParams()
  const params = useParams()
  const ref = useRef(null)
  const [programDetail, setProgramDetail] = React.useState({})
  const [value, setValue] = React.useState(0)
  const [programRatings, setProgramRatings] = React.useState([])
  const [addOnProgramRatings, setAddOnProgramRatings] = React.useState([])
  const [courseRatings, setCourseRatings] = React.useState([])
  const [programReviewSettings, setProgramReviewSettings] = React.useState([])
  const [addOnProgramReviewSettings, setAddOnProgramReviewSettings] = React.useState([])
  const [courseReviewSettings, setCourseReviewSettings] = React.useState([])
  const [attachedProgramDetail, setAttachedProgramDetail] = React.useState({})
  const [addOnProgramDetail, setAddOnProgramDetail] = React.useState(false)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const addOnProgramDetailToggle = (attachedProgramId, realmName) => {
    if (!addOnProgramDetail) {
      getAttachedProgramCoursesList(attachedProgramId, realmName)
    }
    setAddOnProgramDetail(!addOnProgramDetail)
  }

  const viewCourse = () => {
    setValue(2)
  }

  const getProgramDetail = () => {
    fetchProgramCoursesByIdOpen(
      progId,
      (data) => {
        setProgramDetail(data)
      },
      (err) => {
        if (err?.response?.status === 404 || err?.response?.data?.code === ERR_PROGRAM_IN_ACTIVE) {
          history.replace(getSchoolUrl({ ...params, to: ROUTES.NOTFOUND }))
        }
      }
    )
  }

  const enrollProgram = (id) => {
    if (isEmpty(user)) {
      history.push(
        getSchoolUrl({
          ...params,
          to: `${ROUTES.REGISTER}?pid=${id.toString()}`,
        })
      )
    } else {
      history.push(
        getSchoolUrl({
          ...params,
          to: `${ROUTES.LOGIN}/auth?pid=${id}`,
        })
      )
    }
  }

  const fetchRatings = (programId) => {
    const queryParams = programId.map((id) => `pgm_id[]=${id}`).join('&')
    fetchPublicAggregateRatingsCall(
      queryParams,
      (data) => {
        setProgramRatings(data)
      },
      noop
    )
  }

  const fetchAddOnProgramRatings = (programId) => {
    const queryParams = programId.map((id) => `pgm_id[]=${id}`).join('&')
    fetchPublicAggregateRatingsCall(
      queryParams,
      (data) => {
        setAddOnProgramRatings(data)
      },
      noop
    )
  }

  const getAttachedProgramCoursesList = (attachedProgramId, realmName) => {
    fetchAttachedProgramCoursesByIdOpen(
      attachedProgramId,
      realmName,
      (data) => {
        setAttachedProgramDetail(data)
      },
      (err) => {
        if (err?.response?.status === 404 || err?.response?.data?.code === ERR_PROGRAM_IN_ACTIVE) {
          history.replace(getSchoolUrl({ ...params, to: ROUTES.NOTFOUND }))
        }
      }
    )
  }

  const fetchCourseRatings = (CourseGroupIds) => {
    const queryParams = CourseGroupIds.map((id) => `cgi_id[]=${id}`).join('&')

    fetchPublicAggregateRatingsCall(
      queryParams,
      (data) => {
        setCourseRatings(data)
      },
      () => {}
    )
  }

  const updatedProgramDetail = useMemo(() => {
    if (!programDetail?.pgm_program_course_group) {
      return programDetail
    }

    const updatedCourseGroupWithRatingsAndSettings = programDetail.pgm_program_course_group.map(
      (group) => {
        const updatedCourseItems = group.cg_course_group_item.map((courseItem) => {
          const matchingRating = courseRatings.find((data) => courseItem.cgi_id === data.cgi_id)
          const matchingReviewSetting = courseReviewSettings.find(
            (data) => courseItem.cgi_id == data.cgi_id
          )

          return {
            ...courseItem,
            aggregateRating: matchingRating
              ? matchingRating.aggregateRating
              : courseItem.aggregateRating,
            totalRatings: matchingRating ? matchingRating.totalRatings : courseItem.totalRatings,
            context_data: matchingReviewSetting
              ? {
                  ...courseItem.context_data,
                  ...matchingReviewSetting.context_data,
                }
              : courseItem.context_data,
          }
        })

        return { ...group, cg_course_group_item: updatedCourseItems }
      }
    )

    return { ...programDetail, pgm_program_course_group: updatedCourseGroupWithRatingsAndSettings }
  }, [programDetail, courseRatings, courseReviewSettings])

  const checkRatingReviewStatusAndReviewSettings = (pgm_id) => {
    const queryParams = pgm_id.map((id) => `pgm_id[]=${id}`).join('&')
    // const context_id = ''
    fetchPublicRatingReviewStatus(
      queryParams,
      // context_id,
      (data) => {
        setProgramReviewSettings(data)
      },
      noop
    )
  }
  const checkRatingReviewStatusAndReviewSettingsForAddOnProgram = (pgm_id) => {
    const queryParams = pgm_id.map((id) => `pgm_id[]=${id}`).join('&')
    // const context_id = ''
    fetchPublicRatingReviewStatus(
      queryParams,
      // context_id,
      (data) => {
        setAddOnProgramReviewSettings(data)
      },
      noop
    )
  }

  const checkRatingReviewStatusAndReviewSettingsForCourse = (CourseGroupIds) => {
    const queryParams = CourseGroupIds.map((id) => `cgi_id[]=${id}`).join('&')
    // const context_id = ''
    fetchPublicRatingReviewStatus(
      queryParams,
      // context_id,
      (data) => {
        setCourseReviewSettings(data)
      },
      noop
    )
  }

  React.useEffect(() => {
    const headerData = {
      activeMenuItem: MENUITEMS.PROGRAM_COURSES,
      activeParent: MENUITEMS.ENROLLMENTS,
    }
    headerAction(headerData)
  }, [])

  React.useEffect(() => {
    getProgramDetail()
  }, [])

  React.useEffect(() => {
    if (isEmpty(programDetail)) {
      return
    }
    if (programDetail) {
      fetchRatings([programDetail?.pgm_id])
      checkRatingReviewStatusAndReviewSettings([programDetail?.pgm_id])

      fetchAddOnProgramRatings([programDetail?.pgm_attached_pgm?.ap_pgm_source_id])
      checkRatingReviewStatusAndReviewSettingsForAddOnProgram([
        programDetail?.pgm_attached_pgm?.ap_pgm_source_id,
      ])

      const CourseGroupIds = programDetail?.pgm_program_course_group?.flatMap((group) =>
        group?.cg_course_group_item.map((item) => item.cgi_id)
      )
      if (CourseGroupIds?.length) {
        fetchCourseRatings(CourseGroupIds)
        checkRatingReviewStatusAndReviewSettingsForCourse(CourseGroupIds)
      }
    }
  }, [programDetail])

  const allHeadCells = [
    {
      id: 'course_code',
      label: t('courseCode'),
      isSort: false,
      sortProperty: 'course_code',
      width: '150px',
    },
    {
      id: 'cr_course_alias',
      label: t('courseAlias'),
      isSort: false,
      sortProperty: 'cr_course_alias',
      width: '350px',
    },
    {
      id: 'ratings',
      label: t('ratings'),
      isSort: false,
      sortProperty: 'ratings',
    },
    {
      id: 'cr_price',
      label: t('coursePrice'),
      isSort: false,
      sortProperty: 'cr_price',
      width: '150px',
    },
    {
      id: 'cr_credit',
      label: t('credit'),
      isSort: false,
      sortProperty: 'cr_credit',
      width: '150px',
    },
  ]

  /**
   * renders JSX of Available Program Detail container
   * @param Available Program Detail
   */

  return (
    <>
      <AvailableProgramDetail
        allHeadCells={allHeadCells}
        programDetail={updatedProgramDetail}
        value={value}
        handleChange={handleChange}
        viewCourse={viewCourse}
        readOnlyMode={true}
        user={user}
        enrollProgram={enrollProgram}
        school={school}
        programRatings={programRatings}
        programReviewSettings={programReviewSettings}
        getAttachedProgramCoursesList={getAttachedProgramCoursesList}
        attachedProgramDetail={attachedProgramDetail}
        addOnProgramRatings={addOnProgramRatings}
        addOnProgramReviewSettings={addOnProgramReviewSettings}
        addOnProgramDetailToggle={addOnProgramDetailToggle}
        addOnProgramDetail={addOnProgramDetail}
        metadata={metadata}
      />
      <LoadingBar ref={ref} />
    </>
  )
}
ProgramDetailsOpenContainer.propTypes = {
  headerAction: PropTypes.func,
  fetchProgramCoursesByIdOpen: PropTypes.func,
  user: PropTypes.object,
  fetchPublicAggregateRatingsCall: PropTypes.func,
  school: PropTypes.object,
  fetchPublicRatingReviewStatus: PropTypes.func,
  fetchAttachedProgramCoursesByIdOpen: PropTypes.func,
  metadata: PropTypes.object,
}

ProgramDetailsOpenContainer.defaultProps = {
  headerAction: noop,
  fetchProgramCoursesByIdOpen: noop,
  user: {},
  fetchPublicAggregateRatingsCall: noop,
  school: {},
  fetchPublicRatingReviewStatus: noop,
  fetchAttachedProgramCoursesByIdOpen: noop,
  metadata: {},
}

const mapStateToProps = (state) => ({
  user: selectUser(state),
  school: selectSchool(state),
  metadata: selectMetaData(state),
})

/**
 *  @exports connect function of redux
 */
export default withStudentDetails(
  withRouteContext(
    connect(mapStateToProps, {
      headerAction,
      fetchPublicAggregateRatingsCall,
      fetchPublicRatingReviewStatus,
      fetchProgramCoursesByIdOpen,
      fetchAttachedProgramCoursesByIdOpen,
    })(ProgramDetailsOpenContainer)
  )
)
